import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=07754148&scoped=true&"
import script from "./Individual.vue?vue&type=script&lang=js&"
export * from "./Individual.vue?vue&type=script&lang=js&"
import style0 from "./Individual.vue?vue&type=style&index=0&id=07754148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07754148",
  null
  
)

export default component.exports